import axios from 'axios';
import { scheduleKey as KEY } from '../../schemas/config';
import normalise from '../../schemas/normalizr';
import { AWS_ENDPOINT, EPG_REGION } from '../../constants';
import * as TYPES from './schedule.types';
import selectScheduleItems from './schedule.selectors';
import { Dispatch } from 'redux';
import { State } from './schedule';

type GetState = () => State;

/**
 * FetchScheduleData from API and spread into store.
 *
 * @param {string} date
 */
export default function fetchScheduleData(date: string) {
  return async (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const scheduleItems = selectScheduleItems(state, date);
    if (scheduleItems && scheduleItems.length > 0) {
      dispatch({ type: TYPES.EXIST });
      return scheduleItems;
    }

    dispatch({ type: TYPES.LOAD, payload: true });

    const url = `${AWS_ENDPOINT}/${EPG_REGION}/${date}.json`;

    try {
      const response = await fetchWithRetry(url);

      if (response?.status !== 200) {
        console.error('Request failed:', response);
        dispatch({ type: TYPES.LOAD_FAIL });
        return false;
      }

      const payload = normalise(response.data, KEY);
      dispatch({ type: TYPES.ADDED, payload });

      return true;
    } catch (error: unknown) {
      const errorInfo = {
        date,
        url,
        error: axios.isAxiosError(error)
          ? {
              message: error.message,
              status: error.response?.status,
              data: error.response?.data,
            }
          : { message: (error as Error).message },
      };

      console.error('Error fetching schedule data:', errorInfo);

      dispatch({ type: TYPES.LOAD_FAIL });
      return false;
    }
  };
}

const fetchWithRetry = async (url: string, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      return await axios.get(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        timeout: 5000,
        withCredentials: false,
      });
    } catch (error) {
      if (i === retries - 1) throw error;
    }
  }
};
